"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgDrop = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11.294 1.291a86.34 86.34 0 0 0-3.3 3.438 49.235 49.235 0 0 0-2.547 3.02c-.76.993-1.442 2.01-1.792 2.876a9 9 0 1 0 16.69 0c-.35-.865-1.032-1.883-1.792-2.876a49.207 49.207 0 0 0-2.548-3.02 86.197 86.197 0 0 0-3.3-3.438.998.998 0 0 0-1.41 0Z", fill: "currentColor" }) }))); };
exports.default = SvgDrop;
